import { AxiosError } from 'axios';
import { IResponse,  } from './interface';
import moment from 'moment';


export const STATUS = {
    SUCCESS: 'success',
    ERROR: 'error'
}

export const parseAxiosError = (error: AxiosError): IResponse => {
    const errorObject: any = error?.response?.data || error;
    return {
      status: errorObject?.status,
      statusCode: errorObject?.statusCode,
      message: errorObject?.message,
      data: [],
      ...(errorObject?.error && {
        error: errorObject?.error,
      }),
    };
}


export const formatTimeWithMoment = (timeStr: string) => {
    const duration = moment.duration(timeStr);
    
    const hours = duration.hours();
    const minutes = duration.minutes();
  
    let formattedTime = '';
  
    if (hours > 0) {
      formattedTime += `${hours}h `;
    }
  
    if (minutes > 0) {
      formattedTime += `${minutes}m `;
    }
  
    return formattedTime.trim();
}

export const convertToSeconds = (timeString: string): number => {
  const weeks = parseInt(timeString.match(/(\d+)\s*w/)?.[1] || "0", 10);
  const days = parseInt(timeString.match(/(\d+)\s*d/)?.[1] || "0", 10);
  const hours = parseInt(timeString.match(/(\d+)\s*h/)?.[1] || "0", 10);
  const minutes = parseInt(timeString.match(/(\d+)\s*m/)?.[1] || "0", 10);

  return (weeks * 604800) + (days * 86400) + (hours * 3600) + (minutes * 60);
};

export const platforms = {
  OPEN_PROJECT: 'OPEN_PROJECT',
  JIRA: 'JIRA',
}